import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function Hero() {
  const {
    t,
    language
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <>
      <section className="relative min-h-screen w-full overflow-hidden px-4 pt-20 pb-16 flex items-center" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-198">
        {/* Subtle background accent */}
        <div className="absolute inset-0 overflow-hidden opacity-20" data-id="element-199">
          <div className="absolute top-1/4 right-1/4 w-[600px] h-[600px] rounded-full blur-3xl" style={{
          background: 'radial-gradient(circle, var(--accent) 0%, transparent 70%)'
        }} data-id="element-200" />
        </div>

        <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col md:flex-row items-center justify-center gap-8 md:gap-12 lg:gap-16" data-id="element-201">
          {/* Left side - Content */}
          <div className="w-full md:flex-1 text-center md:text-left" data-id="element-202">
            {/* H1 - Main page heading */}
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="mb-6 text-4xl leading-tight tracking-tight md:text-5xl lg:text-6xl" style={{
            color: 'var(--text-primary)'
          }} data-id="element-203">
              {t('hero.title')}{' '}
              <span className="inline-block px-4 py-1 sm:px-5 sm:py-2 mt-2 sm:mt-0 rounded-2xl sm:rounded-3xl shadow-md whitespace-nowrap" style={{
              backgroundColor: 'var(--accent)',
              color: '#FFFFFF'
            }} data-id="element-204">
                {t('hero.titleHighlight')}
              </span>
            </motion.h1>

            {/* Video - Mobile only */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8,
            delay: 0.5
          }} className="block md:hidden mb-8 rounded-xl overflow-hidden shadow-2xl border border-[var(--border)]" data-id="element-205">
              <video src="https://cdn.magicpatterns.com/uploads/3rPLLyoyg624hq2VnbLQCY/original-2de319f4767c5a0d4acf4f107b938504.mp4" autoPlay loop muted playsInline className="w-full h-auto" data-id="element-206" />
            </motion.div>

            {/* Subtitle - NOT h2, just a paragraph */}
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="mb-8 max-w-lg mx-auto md:mx-0 text-lg md:text-xl font-medium" style={{
            color: 'var(--text-primary)'
          }} data-id="element-207">
              {t('hero.subtitle').replace(/€299|\$350|\$249/g, price)}
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-208">
              <motion.button onClick={() => setIsPopupOpen(true)} whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="group flex items-center justify-center gap-2 rounded-lg px-8 py-4 font-semibold transition-all" style={{
              backgroundColor: 'var(--accent)',
              color: '#FFFFFF'
            }} data-id="element-209">
                {t('hero.cta')}
                <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-210" />
              </motion.button>
            </motion.div>
          </div>

          {/* Right side - Video (Desktop only) */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="hidden md:flex md:flex-1 items-center justify-center h-full" data-id="element-211">
            <div className="relative w-full max-w-2xl mx-auto rounded-2xl overflow-hidden shadow-2xl border border-[var(--border)]" data-id="element-212">
              <video src="https://cdn.magicpatterns.com/uploads/3rPLLyoyg624hq2VnbLQCY/original-2de319f4767c5a0d4acf4f107b938504.mp4" autoPlay loop muted playsInline className="w-full h-auto" data-id="element-213" />
            </div>
          </motion.div>
        </div>
      </section>

      {/* Contact Form Popup */}
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-214" />
    </>;
}